export const TEXTAREA_MIN_LENGTH = 3;
export const TEXTAREA_MAX_LENGTH = 1000;

export const PHONE_NUMBER_FIRST_CHAR = /[0-9+()]/;
export const PHONE_NUMBER_OTHER_CHARS = /[0-9()\-\s]/;
export const PHONE_NUMBER_REGEX = /^[+?0-9()\-\s]{5,20}$/;
export const NIP_PL_REGEX = /^\d{10}$/;
export const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]{3,64}@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const WEBSITE_REGEX = /^(https?:\/\/)?([\w-]+\.)+[\w-]{2,}(\/[\w\-._~:/?#[\]@!$&'()*+,;=]*)?$/;
export const MIN_DATE = '1900-01-01';
